import React from 'react';

import { useCurrentVersionReadOnlyReason } from 'app/developer-v3/hooks';

type Props = {
  Component: React.ComponentType<any>;
  alias: string;
};

/*
 * A component wraps useCurrentVersionReadOnlyReason for class components.
 *
 * @param {React.ComponentType<any>} Component A component to render.
 * @param {string} alias A prop name passed to Component, holding a boolean
 * value to indicate if the currentVersion is read-only. Default: isReadOnly.
 */
export default function CurrentVersionReadOnlyReasonWrapper(props: Props) {
  const { alias = 'isReadOnly', Component, ...restProps } = props;
  const reason = useCurrentVersionReadOnlyReason();
  const isReadOnly = !!reason;
  restProps[alias] = isReadOnly;

  return <Component {...restProps} />;
}
